import { render, staticRenderFns } from "./rename-modal.vue?vue&type=template&id=5ff507e9&scoped=true"
import script from "./rename-modal.vue?vue&type=script&lang=js"
export * from "./rename-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff507e9",
  null
  
)

export default component.exports